import requestUtils from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-business'

export type UpdateEmployeeNotificationPayload = paths['/api/business-traveller/businesses/{businessId}/employees/notification-state']['patch']['requestBody']['content']['application/json']

interface RequestParams {
  businessId: string
}

async function requestPatchEmployeeNotification(
  params: RequestParams,
  payload: UpdateEmployeeNotificationPayload,
) {
  await requestUtils.patch<null, UpdateEmployeeNotificationPayload>(
    `/api/business-traveller/businesses/${params.businessId}/employees/notification-state?without_brand=1`,
    payload,
    { credentials: 'include' },
  )
  return true
}

export default requestPatchEmployeeNotification
